import { createRouter, createWebHistory } from 'vue-router'
import HomeView from '../views/HomeView.vue'
import LoginPage from '@/views/LoginPage.vue'
import AdminView from '@/views/admin/AdminView.vue'
import EditInstituteView from '@/views/admin/EditInstituteView.vue'
import MoreTeacherDetails from '@/views/admin/teacher/MoreTeacherDetails.vue'
import MoreInstituteDetails from '@/views/admin/Institute/MoreInstituteDetails.vue'
import MorePayment from '@/views/admin/paymentDetails/MorePayment.vue'
import MoreStudentDetails from '@/views/admin/student/MoreStudentDetails.vue'
import StudentPayment from '@/views/admin/student/StudentPayment.vue'

const routes = [
  {
    path: '/',
    name: 'home',
    component: HomeView
  },
  {
    path: '/about',
    name: 'about',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/AboutView.vue')
  },

  {
    path: '/login',
    name: 'login',
    component: LoginPage
  },

  {
    path: '/adminHome',
    name: 'adminHome',
    component: AdminView,
    meta: { requiresAuth: true }, // Add a custom meta field
  },

  {
    path: '/adminEditInstitute',
    name: 'adminEditInstitute',
    component: EditInstituteView
  },

  {
    path: '/moreTeacherDetails',
    name: 'MoreTeacherDetails',
    component: MoreTeacherDetails,
    props: route => ({ teacherId: Number(route.query.teacherId) }), // Convert query parameter to number
  },

  {
    path: '/moreInstituteDetails',
    name: 'MoreInstituteDetails',
    component: MoreInstituteDetails,
    props: route => ({ instituteId: Number(route.query.instituteId) }), // Convert query parameter to number
  },

  {
    path: '/morePaymentDetails',
    name: 'MorePayment',
    component: MorePayment, // Your component for showing more details
    props: route => ({ accountId: Number(route.query.accountId) }), // Convert query parameter to number
  },

  {
    path: '/moreStudentDetails',
    name: 'MoreStudentDetails',
    component: MoreStudentDetails, // Your component for showing more details
    props: route => ({ studentId: Number(route.query.studentId) , instituteId: Number(route.query.instituteId)
 }), // Convert query parameter to number
  },

  {
    path: '/studentPayment',
    name: 'StudentPayment',
    component: StudentPayment, // Your component for showing more details
    props: route => ({ studentItemId: Number(route.query.studentItemId) }), // Convert query parameter to number
  },
  
  
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})


router.beforeEach((to, from, next) => {
  // Check if the route requires authentication
  if (to.matched.some(record => record.meta.requiresAuth)) {
    const token = localStorage.getItem('token'); // Retrieve the token from localStorage

    if (token) {
      next(); // Proceed if the token exists
    } else {
      next({ name: 'home' }); // Redirect to the login page if no token
    }
  } else {
    next(); // Proceed if the route does not require authentication
  }
});

export default router
